import {FormControl, InputGroup} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import InputGroupText from "react-bootstrap/InputGroupText";
import ClearIcon from '@mui/icons-material/Clear';
import {useTranslation} from "react-i18next";

function GamesListFilter(props) {
    const [allGames, setAllGames] = useState(true)
    const [newGames, setNewGames] = useState(false)
    const [startedGames, setStartedGames] = useState(false)
    const [finishedGames, setFinishedGames] = useState(false)
    const [searchText, setSearchText] = useState()
    const {t, i18n} = useTranslation('translation', {keyPrefix: 'gamesListFilter'});

    function resolveSearchText(event) {
        setSearchText(event.target.value)
    }

    function filterAllGames() {
        setCheckboxesStatus(!allGames, false, false, false)
    }

    function filterNewGames() {
        setCheckboxesStatus(false, !newGames, false, false)
    }

    function filterStartedGames() {
        setCheckboxesStatus(false, false, !startedGames, false)
    }

    function filterFinishedGames() {
        setCheckboxesStatus(false, false, false, !finishedGames)
    }

    function setCheckboxesStatus(allGames, newGames, startedGames, finishedGames) {
        setAllGames(allGames)
        setNewGames(newGames)
        setStartedGames(startedGames)
        setFinishedGames(finishedGames)
    }

    useEffect(() => {
        doFilter()
    }, [allGames, newGames, startedGames, finishedGames, searchText]);

    function doFilter() {
        props.filter(allGames, newGames, startedGames, finishedGames, searchText)
    }

    function clearSearchText() {
        setSearchText("")
    }

    return (
        <div>
            <div style={{display: "grid", gridTemplateColumns: "1fr 1fr"}}>

                <div>
                    <InputGroup style={{width: "90%", margin: "12px"}}>
                        <InputGroupText>{t('search')}</InputGroupText>
                        <FormControl
                            style={{borderRight: "unset"}}
                            as="input"
                            value={searchText}
                            onChange={event => resolveSearchText(event)} />
                        <InputGroupText
                            size="sm"
                            style={{backgroundColor: "unset", borderLeft: "unset"}}
                            onClick={clearSearchText}><ClearIcon fontSize={"small"}/></InputGroupText>
                    </InputGroup>

                </div>

                <fieldset style={{margin: "12px", display: "grid", gridTemplateColumns: "1fr 1fr"}}>
                    <div>
                        <input type="radio" id="all" name="drone" checked={allGames} onChange={filterAllGames}/>
                        <label style={{marginLeft: "6px"}} htmlFor="all">{t('allGames')}</label>
                    </div>
                    <div>
                        <div>
                            <input type="radio" id='new' checked={newGames} onChange={filterNewGames}/>
                            <label style={{marginLeft: "6px"}} htmlFor="new">{t('newGames')}</label>
                        </div>
                        <div>
                            <input type="radio" id='started' checked={startedGames} onChange={filterStartedGames}/>
                            <label style={{marginLeft: "6px"}} htmlFor="started">{t('startedGames')}</label>
                        </div>
                        <div>
                            <input type="radio" id='finished' checked={finishedGames} onChange={filterFinishedGames}/>
                            <label style={{marginLeft: "6px"}} htmlFor="finished">{t('finishedGames')}</label>
                        </div>
                    </div>

                </fieldset>
            </div>
        </div>
    )
}

export default GamesListFilter;